import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLocaleStore = defineStore('locale', () => {
  let saved = 'uk';
  try { saved = localStorage.getItem('pf_lang') || 'uk'; } catch {}

  const lang = ref(saved);

  function setLang(l) {
    lang.value = l;
    try { localStorage.setItem('pf_lang', l); } catch {}
  }

  return { lang, setLang };
});
